import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TabsList from "./TabsList";

export const OPS_PLAN_TAB_DASHBOARD = "dashboard";
export const OPS_PLAN_TAB_MANAGEMENT = "management";
export const OPS_PLAN_TAB_PROGRAMS = "programs";

/**
 * Cross-route tabs between Ops Plan Dashboard, Ops Plan Management, and Program Management.
 */
export default function OpsPlanSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showDashboard = hasPermission && hasPermission("menu.ops_plan_dashboard");
  const showManagement = hasPermission && hasPermission("menu.operating_plan");
  const showPrograms = hasPermission && hasPermission("menu.programs");

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Ops Plan sections">
      {showDashboard ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === OPS_PLAN_TAB_DASHBOARD}
          className={`tab-btn ${activeTab === OPS_PLAN_TAB_DASHBOARD ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== OPS_PLAN_TAB_DASHBOARD) navigate("/OpsPlanDashboard");
          }}
        >
          Ops Plan Dashboard
        </button>
      ) : null}
      {showManagement ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === OPS_PLAN_TAB_MANAGEMENT}
          className={`tab-btn ${activeTab === OPS_PLAN_TAB_MANAGEMENT ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== OPS_PLAN_TAB_MANAGEMENT) navigate("/OperatingPlan?tab=aopByProgram");
          }}
        >
          Ops Plan Management
        </button>
      ) : null}
      {showPrograms ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === OPS_PLAN_TAB_PROGRAMS}
          className={`tab-btn ${activeTab === OPS_PLAN_TAB_PROGRAMS ? "active" : ""}`}
          onClick={() => {
            if (activeTab !== OPS_PLAN_TAB_PROGRAMS) navigate("/ProgramManagement");
          }}
        >
          Program Management
        </button>
      ) : null}
    </TabsList>
  );
}
